// type of notification
export enum OneSignalAdditionalDataType {
  Blog = 'blog',
  TransactionDetail = 'transactionDetail',
  Chatroom = 'chat',
}
